import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
var components = require.context('./', false, /\.vue$/);
export default (function (Vue) {
  components.keys().map(function (item) {
    Vue.component(components(item).default.name, components(item).default);
  });
});